import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Input, Select, Button, Space } from "antd";
import { Upload } from "antd";
import { PlusCircleTwoTone, UploadOutlined } from "@ant-design/icons";

import Sidebar from "../../../components/AdminComponents/SideNav";
import { ClientMenu } from "../../../components/AdminComponents/MenuItems";
import Axios from "../../../api/Axios";
import { message } from "antd";
import { BackwardOutlined, SaveOutlined } from "@ant-design/icons";
import axios from "axios";
import SecondaryNav from "../../../components/AdminComponents/SecondaryNav2";
import { capitalizeWords } from "../../../components/icons/ApplicationColor";
const { Option } = Select;

const ModuleAdd = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const [fileName, setFileName] = useState("");

  const formRef = useRef();
  const handleReset = () => {
    formRef.current.resetFields();
  };
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  //console.log(csrfToken);
  const onFinish = async (values) => {
    const normalizedValues = Object.fromEntries(
      Object.entries(values).map(([key, value]) => [
        key,
        value === undefined ? null : value,
      ])
    );

    if (fileName !== "") {
      normalizedValues.logo = fileName;
    } else {
      normalizedValues.logo = null; // or any other appropriate value
    }
    //console.log(normalizedValues);
    try {
      await Axios.post("/applicationcreate/", normalizedValues, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      CreateSuccessfull();
    } catch (err) {
      //console.log(err);
      CreateFailed();
    }
  };
  const CreateSuccessfull = () => {
    messageApi.open({
      type: "success",
      content: "New Module has been created.",
      duration: 5,
    });
    setTimeout(() => {
      history("/admin-manager/modules");
    }, 2000);
  };

  const CreateFailed = () => {
    messageApi.open({
      type: "error",
      content: "Module has not been Created.",
      duration: 5,
    });
  };
  const history = useNavigate();
  const uploadImage = async (data) => {
    //console.log(data);

    //console.log(data.file.name);
    const payload = {
      filename: data.file.name,
      type: "application",
    };
    try {
      const response = await Axios.post("/uploadurl/", payload, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(response);
      const file_name = response.data.filename;
      const url = response.data.url;
      //console.log(file_name, url);

      try {
        const res = await axios.put(
          url,
          data.file
          //    {
          //   headers: {
          //     "X-CSRFToken": csrfToken,
          //   },
          //   withCredentials: true,
          // }
        );
        //console.log(res);
        if (res.status === 200) {
          data.onSuccess();
          setFileName(file_name);
        } else {
          data.onError();
        }
      } catch {
        data.onError();
      }

      // setFile(file.name);
    } catch (error) {
      // Handle any errors that occur during the upload
      console.error("Error uploading file:", error);
      // You may want to set an error state or show an error message here
    }
  };
  const handleRemove = () => {
    setFileName("");
  };
  const thirdMenuData = [
    {
      path: `/admin-manager/modules/add-user`,
      name: " MANAGE MODULE",
      icon: (
        <PlusCircleTwoTone
          style={{ fontSize: "15.5px", marginRight: "5px", margintop: "1px" }}
        />
      ),
    },
  ];
  return (
    <div className="page-scroller">
      <Sidebar props={ClientMenu}>
        {contextHolder}
        <SecondaryNav menuItems={thirdMenuData} />
        <div className="form-container">
          <Form
            name="complex-form"
            onFinish={onFinish}
            layout="vertical"
            ref={formRef}
            labelCol={{
              span: 14,
            }}
            wrapperCol={{
              span: 16,
            }}
            style={{
              Width: "100%",
            }}
          >
            <div className="group1">
              <div className="form-heading">
                {capitalizeWords("ADD NEW MODULE")}
              </div>
              <div className="group-1-box">
                <div style={{ display: "inline-block" }}>
                  <Form.Item
                    label={<p className="my-form-lables">Module ID</p>}
                  >
                    <Space>
                      <Form.Item
                        name="app_id"
                        noStyle
                        rules={[
                          { required: true, message: "ID is required" },
                          {
                            pattern: /^[a-zA-Z0-9]*$/,
                            message:
                              "Please enter alphanumeric characters only",
                          },
                        ]}
                      >
                        <Input
                          className="my-form-input"
                          placeholder={
                            //   errors.username
                            //     ? `${errors.username}`
                            //     :
                            "Enter Module ID"
                          }
                        />
                      </Form.Item>
                    </Space>
                  </Form.Item>
                </div>
                <div style={{ display: "inline-block", marginLeft: "2rem" }}>
                  <Form.Item
                    label={<p className="my-form-lables">Module Name</p>}
                  >
                    <Space>
                      <Form.Item
                        name="name"
                        noStyle
                        rules={[
                          { required: true, message: "name is required" },
                        ]}
                      >
                        <Input
                          className="my-form-input"
                          placeholder="Enter Module name"
                        />
                      </Form.Item>
                    </Space>
                  </Form.Item>
                </div>
              </div>
              <div className="group-1-box" style={{ paddingTop: "1rem" }}>
                <div style={{ display: "inline-block" }}>
                  <Form.Item
                    label={<p className="my-form-lables">Module Type</p>}
                  >
                    <Input.Group compact>
                      <Form.Item
                        name="type"
                        noStyle
                        initialValue={"SaaS"}
                        rules={[
                          {
                            required: true,
                            message: "Type is required",
                          },
                        ]}
                      >
                        <Select
                          placeholder="Select Type"
                          className="my-form-input"
                        >
                          <Option value="SaaS">SaaS</Option>
                        </Select>
                      </Form.Item>
                    </Input.Group>
                  </Form.Item>
                </div>

                <div style={{ display: "inline-block", marginLeft: "2rem" }}>
                  <Form.Item label={<p className="my-form-lables">Status</p>}>
                    <Input.Group compact>
                      <Form.Item
                        name="status"
                        noStyle
                        rules={[
                          {
                            required: true,
                            message: "status is required",
                          },
                        ]}
                        initialValue={true}
                      >
                        <Select
                          placeholder="Select Status"
                          className="my-form-input"
                        >
                          <Option value={true}>Active</Option>
                          <Option value={false}>Unactive</Option>
                        </Select>
                      </Form.Item>
                    </Input.Group>
                  </Form.Item>
                </div>
              </div>
              <div className="group-1-box" style={{ paddingTop: "1rem" }}>
                <div style={{ display: "inline-block" }}>
                  <Form.Item label={<p className="my-form-lables">Category</p>}>
                    <Input.Group compact>
                      <Form.Item
                        name="category"
                        noStyle
                        rules={[
                          {
                            required: true,
                            message: "type is required",
                          },
                        ]}
                      >
                        <Select
                          placeholder="Select Category"
                          className="my-form-input"
                        >
                          <Option value="TraineryHCM">Trainery HCM</Option>
                          <Option value="TraineryTrak">Trainery Trak</Option>
                        </Select>
                      </Form.Item>
                    </Input.Group>
                  </Form.Item>
                </div>
                <div style={{ display: "inline-block", marginLeft: "2rem" }}>
                  <Form.Item
                    label={<p className="my-form-lables">Module Logo</p>}
                  >
                    <Input.Group compact>
                      <Form.Item
                        name="logo"
                        noStyle
                        valuePropName="fileList"
                        getValueFromEvent={(event) => {
                          if (Array.isArray(event)) {
                            return event;
                          }
                          return event && event.fileList;
                        }}
                      >
                        <Upload
                          name="logo"
                          customRequest={uploadImage}
                          listType="picture"
                          className="my-form-input"
                          onRemove={handleRemove}
                        >
                          <Button
                            icon={<UploadOutlined />}
                            className="my-form-input"
                            style={{
                              width: "35rem",
                              marginLeft: "0.5rem",
                              borderRight: "0",
                              borderLeft: "0",
                              border: "0",
                              borderRadius: "0",
                            }}
                          >
                            Upload Logo
                          </Button>
                        </Upload>
                      </Form.Item>
                    </Input.Group>
                  </Form.Item>
                </div>
              </div>
            </div>

            <div style={{ display: "inline-block", marginLeft: "5rem" }}>
              <Form.Item label=" " colon={false}>
                <Button
                  type="text"
                  htmlType="button"
                  style={{
                    background: "#D3D3D3",
                  }}
                  onClick={() => {
                    history("/admin-manager/modules");
                  }}
                >
                  <BackwardOutlined />
                  Back
                </Button>
              </Form.Item>
            </div>

            <div style={{ display: "inline-block", marginLeft: "16px" }}>
              <Form.Item label=" " colon={false}>
                <Button type="primary" htmlType="button" onClick={handleReset}>
                  Reset
                </Button>
              </Form.Item>
            </div>
            <div style={{ display: "inline-block", marginLeft: "16px" }}>
              <Form.Item label=" " colon={false}>
                <Button
                  type="primary"
                  htmlType="submit"
                  // className="my-form-input-end"
                  style={{
                    background: "#f58029",
                    fontWeight: "600",
                  }}
                  className="save-update-btn"
                >
                  Save
                  <SaveOutlined />
                </Button>
              </Form.Item>
            </div>
          </Form>
        </div>
      </Sidebar>
    </div>
  );
};

export default ModuleAdd;
